import script from "./ExplainConfigButton.vue?vue&type=script&setup=true&lang=js"
export * from "./ExplainConfigButton.vue?vue&type=script&setup=true&lang=js"

import "./ExplainConfigButton.vue?vue&type=style&index=0&id=2a0d9fd0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2a0d9fd0"]])

export default __exports__